 ;
 <template>
  <div class="d-flex flex-row row justify-content-center">
    <div class="col-md-6 ms-2 ">
      <input class="form-control py-2 border-right-0 border" v-model="search" type="search"
             @keyup="CustomersSeerach()"
             placeholder="جستجوی براساس کد رهیگری و عنوان آزمون">
    </div>
    <div class="col-md-3 ms-2  ">
      <select v-model="cat_id" class="btn" @change="CustomersSeerach()">
        <option disabled value=""> لیست دسته بندی ها</option>
        <option v-for=" (cats  , index )  in listCate" :value="cats.id">{{ cats.title }}</option>
      </select>
    </div>
  </div>
  <div class="d-flex flex-row justify-content-lg-center mt-3">
    <div class="p-2 card w-100 ">
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">#</th>
          <th :title="comments">کد رهگیری</th>
          <th scope="col">ایمیل</th>
          <th scope="col">عنوان آزمون</th>
          <th scope="col">تعداد سوالات</th>
          <th scope="col">تعداد پاسخ های داده شد کاربر</th>
          <th scope="col">تعداد پاسخ های صیحیح</th>
          <th scope="col">تاریخ آزمون</th>
          <th scope="col">لینک دانلود و مشاهد مدارک</th>
          <th scope="col"> مشاهد</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(list , index)  in listCustomers">
          <td>{{ list.id }}</td>
          <td>{{ list.examination_code }}</td>
          <td>{{ list.email }}</td>
          <td>{{ list.title }}</td>
          <td>{{ list.count }}</td>
          <td>{{ list.answers_user }}</td>
          <td>{{ list.countAnswers }}</td>
          <td>{{ converDatePersian(list.date) }}</td>
          <td v-if="checkAccepteds(list.examination_code) != false  || checkAccepteds(list.examination_code) === 0">
            <a v-if="checkAccepteds(list.examination_code) !== 0"
               :href="imagesUrl+'/public/images/'+checkAccepteds(list.examination_code)+'.png'" target="_blank"
               class="btn link-success"><i class="fa fa-eye" title="مشاهد مدارک ازمون"></i>
            </a>
            <a v-else href="#" class="btn link-success"> <i class="fa fa-check" title="قبول شد"></i> </a>
          </td>
          <td v-else>
            <a href="#" class="btn link-danger" title="قبول نشده"> <i class="fa fa-times-circle"></i></a>
          </td>
          <td>
            <router-link :to="`/panel/customers/answer/${list.examination_code}`" class="title"><i
                class="fa fa-address-card fs-5" style="color: #00B4CF" title="مشاهد جزییات نتایع آزمون"></i>
            </router-link>
          </td>
        </tr>
        <tr>
          <td colspan="10">
            <nav class="text-danger">
              <ul class="pagination  " style="justify-content: center;">
                <li class="page-item">
                  <button class="btn btn-light " :disabled="!paginatetion.first_page_url" href="#"
                          v-on:click="myPaginate(paginatetion.first_page_url)" title="اولین"><i
                      class="fa fa-angle-double-right"></i></button>
                  <button class="btn btn-light " :disabled="!paginatetion.prev_page_url" href="#"
                          v-on:click="myPaginate(paginatetion.prev_page_url)" title="قبلی"><i
                      class="fa fa-angle-right"></i></button>
                </li>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <li class="page-item">
                  <button class="btn btn-light" v-on:click="myPaginate(paginatetion.next_page_url)"
                          :disabled="!paginatetion.next_page_url" title="بعدی">
                    <i class="fa fa-angle-left"></i></button>

                  <button class="btn btn-light " :disabled="!paginatetion.last_page_url" href="#"
                          v-on:click="myPaginate(paginatetion.last_page_url)" title="اخرین"><i
                      class="fa fa-angle-double-left"></i></button>
                </li>
              </ul>
            </nav>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script setup>
import {$ref} from "vue/macros";
import config from "../../../../config/config.json";
import axios from "axios";
import {converDatePersian} from "@/common/helpers/useFunctionsDate";
import {cats} from "../../mixins/cats";

let listCustomers = $ref({});
let listAccepteds = $ref({});
let listCate = $ref({});

let url = $ref(`${config.BASE_URL}/customers`);
const imagesUrl = $ref(`${config.BACKEND_URL}`);
let comments = $ref("این کد مخصوص کسانی می باشند که در  آزمون شرکت کردن و در زمان پیگر و در یافت مدارک از این کد استفاده می کند");
let paginatetion = $ref({});
let search = $ref("");
let cat_id = $ref("");


function getCustomers() {
  axios.get(url)
      .then(function (res) {
        if (res.data.status) {
          makePaginatetion(res.data.data[0]);
          listAccepteds = res.data.data[1];
          listCate = res.data.data[2];
          return listCustomers = res.data.data[0].data;
        }
      })
      .catch(function (errors) {
      });
}

function checkAccepteds(code) {
  const acceptedItem = listAccepteds.find(item => item.examination_code === code);
  return acceptedItem ? acceptedItem.linke_documents !== '' ? acceptedItem.linke_documents : 0 : false;
}
function CustomersSeerach() {
  if (search === "" && cat_id === "") {
    return getCustomers();
  }
  let params = (search) ? search : (cat_id) ? cat_id : "";
  axios.get(url + '/search/' + params)
      .then(function (res) {
        listCustomers = res.data.data[0];
        listAccepteds = res.data.data[1];
      })
      .catch(function (errors) {
        console.log(errors);
      });
}

function makePaginatetion(data) {
  let paginatetions = {
    current_page: data.current_page,
    last_page_url: data.last_page_url,
    next_page_url: data.next_page_url,
    prev_page_url: data.prev_page_url,
    first_page_url: data.first_page_url
  }
  paginatetion = paginatetions;
}

function myPaginate(urls) {
  url = urls;
  getCustomers()
}

getCustomers();
</script>